import { Accordion } from '@mantine/core';
// components
import { ILog } from '@newo/api/gateway';
import ContentViewer from '@/components/ContentViewer';
import NoRecords from '@/components/NoRecords';
import JSONSchema from '@/modules/ActLogDrawer/components/JSONSchema';
// utils

interface PromptsProps {
    logs: ILog[];
}

type Prompt = {
    value: string;
    result: string;
    schema?: string;
    flowIdn: string;
    skillIdn: string;
    name: string;
};

const Prompts = ({ logs }: PromptsProps) => {
    const callLogs = logs.filter((log) => log.log_type === 'call').toReversed();

    const prompts: Prompt[] = callLogs.flatMap((log) => {
        if (log.data.source_type === 'skill') {
            const prompt = log.data.parameters.find(
                ({ name }) => name === 'prompt'
            )?.value;
            const schema = log.data.parameters.find(
                ({ name }) => name === 'jsonSchema'
            )?.value;
            if (prompt) {
                return [
                    {
                        value: prompt,
                        schema,
                        result: log.data.result,
                        flowIdn: log.data.context.flow_idn,
                        skillIdn: log.data.source.skill_idn,
                        name: log.data.name
                    }
                ];
            }
        }
        return [];
    });

    if (prompts.length === 0) {
        return <NoRecords />;
    }

    return (
        <div className="py-4">
            <Accordion>
                {prompts.map((prompt, index) => (
                    <Accordion.Item key={index} value={`prompt-${index}`}>
                        <Accordion.Control>
                            <div className="flex gap-1 text-sm">
                                <span className="whitespace-nowrap font-bold text-gray-7">
                                    [{prompt.flowIdn}]
                                </span>
                                <span className="whitespace-nowrap font-bold text-gray-7">
                                    [{prompt.skillIdn}]
                                </span>
                                <span className="whitespace-nowrap text-blue-6">
                                    {prompt.name}
                                </span>
                            </div>
                        </Accordion.Control>
                        <Accordion.Panel>
                            <div className="text-xs uppercase font-bold mt-10 mb-2">
                                Prompt:
                            </div>
                            <ContentViewer withCounter content={prompt.value} />

                            {prompt.schema ? (
                                <>
                                    <div className="text-xs uppercase font-bold mt-10 mb-2">
                                        Schema:
                                    </div>

                                    <div className="border border-solid border-gray-4 p-4 rounded-lg">
                                        <JSONSchema value={prompt.schema} />
                                    </div>
                                </>
                            ) : undefined}

                            <div className="text-xs uppercase font-bold mt-10 mb-2">
                                Result:
                            </div>
                            <ContentViewer
                                className="bg-green-1"
                                content={prompt.result}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>
    );
};

export default Prompts;
